import { Directive, Input, ElementRef, OnInit, OnDestroy } from '@angular/core';

import Sortable from 'sortablejs';

@Directive({
  selector: '[appNativeSortableJs]'
})
export class NativeSortableJsDirective implements OnInit, OnDestroy {
  @Input('appNativeSortableJs') items: Array<any> = [];
  @Input() sortableOptions: any = {};

  onUpdate: Function;

  sortableInstance: any;

  constructor(private el: ElementRef) { }

  ngOnInit(): void {
    this.destroySortable();
    if(this.sortableOptions.onUpdate){
      this.onUpdate = this.sortableOptions.onUpdate;
      this.sortableOptions.onUpdate = (event: any) => {
        let itemToSwitch: any = this.items[event.oldIndex];
        this.items[event.oldIndex] = this.items[event.newIndex];
        this.items[event.newIndex] = itemToSwitch;
        this.onUpdate(event);
      }
    }
    this.sortableInstance = Sortable.create(this.el.nativeElement, this.sortableOptions);
  }

  ngOnDestroy(): void {
    this.destroySortable();
  }

  destroySortable(): void {
    if(this.sortableInstance) {
      try{
        this.sortableInstance.destroy();
      }catch(err){
        console.error(err);
      }
    }
  }
}
